<template>
  <div class="user_container">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
      <div class="goback_search">
        <el-input
          v-model="searchValue"
          placeholder="请输入..."
          @input="changeSearchValue"
        ></el-input>
        <i class="el-icon-search"></i>
      </div>
    </div>
    <div class="content" v-if="historyList.length > 0">
      <!-- <van-list
        v-if="historyList.length > 0"
        v-model="loadingOne"
        :finished="finishedOne"
        finished-text="没有更多了"
        @load="onLoadOne"
        loading-text="加载中，下拉查看更多"
        offset="10"
        :immediate-check="false"
      > -->
      <div class="con_item" v-for="(item, index) in historyList" :key="index">
        <div class="title">
          <div class="title_left">{{item.epbActivityName}}</div>
          <!-- 审批通过 status2 待审批status1 审批驳回status3-->
          <!-- <div class="status_con">
            <div class="status status1" v-if="item.state == 1">待审批</div>
            <div class="status status2" v-if="item.state == 2">审批通过</div>
            <div class="status status3" v-if="item.state == 3">审批驳回</div>
          </div> -->
          <!-- <div class="title_right">已报名</div> -->
          <div class="title_right status1" v-if="!item.signInStartTime">已报名</div>
          <div class="title_right status2" v-if="item.signInStartTime">已参加</div>
          <!-- <div class="title_right status3" v-if="item.state == 3">未参加</div> -->
        </div>
        <div class="info_item">
          <div class="info_label">姓名</div>
          <div class="info_value">{{item.empName}}</div>
        </div>
        <div class="info_item">
          <div class="info_label">部门</div>
          <div class="info_value">{{item.departmentName}}</div>
        </div>
        <div class="info_item">
          <div class="info_label">工号</div>
          <div class="info_value">{{item.empNo}}</div>
        </div>
        <div class="info_item">
          <div class="info_label">公益时长</div>
          <div class="info_value" v-if="item.hour">{{item.hour}}/h</div>
          <div class="info_value" v-else>暂无</div>
        </div>
        <div class="info_item">
          <div class="info_label">报名活动日期</div>
          <div class="info_value">{{item.date}}</div>
        </div>
        <div class="info_item">
          <div class="info_label">报名活动时间</div>
          <div class="info_value">{{item.time}}</div>
        </div>
        <!-- <div class="info_item">
          <div class="info_label">实际参与日期</div>
          <div class="info_value">暂无</div>
        </div> -->
        <div class="info_item">
          <div class="info_label">签到时间</div>
          <div class="info_value">{{item.signInStartTime}}</div>
        </div>
        <div class="info_item">
          <div class="info_label">签退时间</div>
          <div class="info_value">{{item.signInEndTime}}</div>
        </div>
      </div>
      <!-- </van-list> -->
    </div>
    <div class="kong_con" v-else>
      <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
      <div class="kong_title kong_title1">暂无历史记录</div>
    </div>
  </div>
</template>

<script>
// import api from "@/apis/medal";
import apis from "@/apis/publicWelfare";
import moment from "moment";
import { getToken } from "@/utils/cookie";
export default {
  name: "history",
  props: {},
  components: {},
  data() {
    return {
      searchValue: "",
      historyList: [],
      loadingOne: false,
      finishedOne: false,
      total: 0,
      page: 1,
      pageSize: 10,
    };
  },
  created() {},
  mounted() {
    this.onLoadOne();
  },
  methods: {
    // 返回
    goback() {
      this.$router.go(-1);
    },
    onLoadOne() {
      this.queryHistoryRecord();
    },
    // 获取历史记录
    queryHistoryRecord() {
      apis
        .history({
          empNo: getToken(),
          type: 1,
          activityName: this.searchValue,
        })
        .then((res) => {
          if (res.code == 200) {
            this.historyList = res.data;
            this.historyList.forEach((item) => {
              if(item.signInStartTime){
                item.signInStartTime = moment(item.signInStartTime).format("YYYY-MM-DD HH:mm");
              } else {
                item.signInStartTime = '暂无';
              }
              if(item.signInEndTime){
                item.signInEndTime = moment(item.signInEndTime).format("YYYY-MM-DD HH:mm");
              } else {
                item.signInEndTime = '暂无';
              }
              if(item.enterTime){
                item.date = moment(item.enterTime).format("YYYY-MM-DD");
                item.time = moment(item.enterTime).format("HH:mm");
              }
            })
            // this.total = res.data.total;
            // this.finishedOne = false;
            // if (this.page === 1) {
            //   this.historyList = res.data.list;
            // } else {
            //   this.historyList = this.historyList.concat(res.data.list);
            // }
            // if (this.historyList.length < this.total) {
            //   this.page = this.page + 1;
            // } else {
            //   this.finishedOne = true;
            // }

            // this.loadingOne = false;
            // this.historyList.map((item) => {
            //   item.create_time = moment(item.create_time).format("YYYY-MM-DD");
            // });
          }
        });
    },
    // 搜索框输入事件
    changeSearchValue() {
      this.queryHistoryRecord();
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px;
  // background: #fff;
  background: url("~@/assets/newMedal/bg2.png");
  background-size: 100% 100%;
  .content {
    margin-top: 30px;
    height: calc(100vh - 230px);
    overflow: auto;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    ::v-deep {
      .van-list__finished-text {
        line-height: 0;
        margin-top: 40px;
      }
    }
    .con_item {
      margin-bottom: 30px;
      border-radius: 35px;
      overflow: hidden;
      background: #fff;
      font-size: 10px * $zoom;
      color: #000;
      padding: 0 0 10px 30px;
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        .title_left {
          font-size: 12px * $zoom;
          font-weight: bold;
        }
        .title_right {
          // color: #0caf60;
          // background: #e7f7ef;
          padding: 15px 30px;
          border-radius: 10px;
        }
        .status1 {
          background: #fee9d2;
          color: #f88100;
        }
        .status2 {
          background: #e7f7ef;
          color: #0caf60;
        }
        .status3 {
          background: #ffe9e9;
          color: #fa6666;
        }
      }
      .info_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        .info_label {
          color: #969b9e;
        }
        .info_value {
          color: #000;
          margin-right: 30px;
        }
      }
    }
  }
  .kong_con {
    width: 100%;
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    justify-content: center;
    .kong_img {
      width: 450px;
      height: 450px;
    }
    .kong_title1 {
      margin-top: 30px !important;
    }
    .kong_title {
      color: #999999;
      font-size: 26px;
      margin-top: 10px;
    }
  }
}
.goback {
  margin: 10px 0 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    // width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
</style>
